import { Wine } from '@/Model/types'
import './WineCard.css'
import { useNavigate } from 'react-router-dom';

interface WineCardProps {
  wine: Wine;
}

const WineCard: React.FC<WineCardProps> = ({ wine }) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate(`/wine/${wine.id}?open=${wine.productId}&wineId=${wine.id}`);

  };
  return (
    <div className='wine-card' onClick={handleClick}>
      <div className="wine-media">
        <img className='wine-image' src={wine.imageUrl} alt={wine.name} />
        {wine.isSoldOut && (
          <img
            className="sold-out-badge"
            src="/Image/agotado.png"
            alt="Agotado temporalmente"
          />
        )}
      </div>
      
      <div className='wine-details'>
        <h1 className='wine-title'>{wine.name}</h1>
        <h1 className='wine-grape'>({wine.grape})</h1>
      </div>
    </div>

  )
}

export default WineCard
